export default __webpack_public_path__ + "static/media/gallery-wps-1.7c4ea72c.jpg";